<template>
  <div class="bear-traffic-actions">
    <div class="bta__left">
      <template v-for="(obj, i) in options.left" :key="i">
        <el-button type="primary" v-if="visible[obj.visible]" @click="obj.call()">{{obj.name}}</el-button>
      </template>
    </div>
    <div class="bta__right">
      <template v-for="(obj, i) in options.right" :key="i">
        <el-button type="primary" v-if="visible[obj.visible]" @click="obj.call()">{{obj.name}}</el-button>
      </template>
    </div>
  </div>
  <el-dialog v-model="loadingVisible"
    top="40vh"
    custom-class="loading-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <p class="ld__message is-loading">
      <i class="el-icon is-loading"><Loading /></i>{{loadingMessage}}
    </p>
  </el-dialog>
  <el-dialog v-model="iframeDialog.visible" 
    top="5vh" 
    :title="iframeDialog.title" 
    :width="iframeDialog.width" 
    :custom-class="iframeDialogClass"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="iframeDialog.call"
  >
    <iframe :src="iframeDialog.href" class="__iframe" :style="iframeStyle" frameborder="0"></iframe>
  </el-dialog>
  <bear-sign :options="signUrlOptions"></bear-sign>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { Loading } from '@element-plus/icons-vue'
import { download } from '@/common/js/utils'
import BearSign from "../../sign/src"
import api from '@/common/js/api'
import trafficUtils from '@/common/tender/traffic/utils'
export default {
  name: 'BearTrafficActions',
  components: {
    Loading,
    BearSign
  },
  data () {
    return {
      options: {
        left: [
          { name: '暂存', visible: 'issave', call: () => this.save(0) },
          { name: '填写日程安排', visible: 'isdate', call: () => this.fillSchedule() },
          { name: '预览招标文件', visible: 'iscreate', call: () => this.doPreview() },
          { name: '上传备案材料', visible: 'islookbaupdate', call: () => this.uploadFiles() },
          { name: '选择保证金银行', visible: 'islookBank', call: () => this.marginPayTypes(1) },
          { name: '邀请企业', visible: 'islookInviteEnterprise', call: () => this.inviteEnterprise(1) },
          { name: '提交备案', visible: 'issubmit', call: () => this.save(1) },
          { name: '发布', visible: 'ispublish', call: () => this.save(2) }
        ],
        right: [
          { name: '复用历史项目信息', visible: 'issave', call: () => this.useHistory() },
          { name: '查看签章文件', visible: 'islook', call: () => this.showSignFile() },
          { name: '查看操作记录', visible: 'islog', call: () => this.showRecords() },
          { name: '查看基本信息', visible: 'visible', call: () => this.showBasic() },
          { name: '查看受邀企业', visible: 'islookShowEnterprise', call: () => this.inviteEnterprise(0) },
          { name: '查看保证金银行', visible: 'islookBankView', call: () => this.marginPayTypes(0) },
          { name: '查看备案材料', visible: 'islookbalook', call: () => this.showFiles() }
        ]
      },
      loadingVisible: false,
      loadingMessage: '',
      iframeDialog: {
        visible: false,
        title: '',
        href: 'about:blank',
        className: '',
        width: '',
        height: '',
        call: () => null
      },
      marginBankKeys: {
        9: 't1871_IF_BID_BOND', // 施工
        15: 't1913_IF_BID_BOND', // 勘察
        16: 't1911_IF_BID_BOND', // 施工监理
        10: 't1873_IF_BID_BOND' // 国省道养护
      }
    }
  },
  computed: {
    ...mapState('electronicMail', ['$electronicMail']),
    ...mapState(['$vm', 'actions', 'baseInfo', 'config', 'pdfInfo', 'form', '$vm', 'modules', "signUrlOptions"]),
    pdfUrl () {
      return `/FileServer/FileDownload.aspx?guid=${this.pdfInfo.PDF_GUID}`
    },
    visible () {
      const { actions, pdfInfo } = this
      return {
        visible: true,
        islook: !!pdfInfo.PDF_GUID,
        issave: actions.indexOf('暂存') >= 0,
        issubmit: actions.indexOf('提交备案') >= 0,
        ispublish: actions.indexOf('发布') >= 0,
        iscreate: actions.indexOf('生成招标文件') >= 0,
        isdate: actions.indexOf('日程安排编辑') >= 0 || actions.indexOf('日程安排查看') >= 0,
        islog: actions.indexOf('操作记录') >= 0,
        islookbaupdate: actions.indexOf('备案材料') >= 0,
        islookbalook: actions.indexOf('备案材料查看') >= 0,
        islookInviteEnterprise: actions.indexOf('邀请企业') >= 0,
        islookShowEnterprise: actions.indexOf('查看邀请企业') >= 0,
        islookBank: actions.indexOf('选择保证金银行') >= 0,
        islookBankView: actions.indexOf('查看保证金银行') >= 0,
        isselfback: actions.indexOf('撤回') >= 0
      }
    },
    iframeDialogClass () {
      return `iframe-dialog ${this.iframeDialog.className}`
    },
    iframeStyle () {
      const { width, height } = this.iframeDialog
      return { width, height }
    }
  },
  methods: {
    ...mapMutations(['setLoading', 'setActions', 'setSignUrlOptions']),
    ...mapActions(['createPdfUrl', 'resetBankInfo', 'scrollToFormItem']),
    doPreview () {
      // console.log('doPreview 预览招标文件', arguments)
      // this.loadingMessage = '生成招标文件中'
      // this.loadingVisible = true

      var viewUrl=window.location.href.replace("edit.html","view.html");
      
      window.open(viewUrl, '_blank')
      // this.createPdfUrl(this.visible.ispublish).then(res => {
      //   this.loadingVisible = false
      //   if (res.status === 0) {
      //     this.$alert(`提交错误，错误信息：${res.info}`, '提示', { type: 'error' })
      //   } else if (res.status === 1) {
      //     this.$alert('招标文件生成成功', '提示', { type: 'success' })
      //     download(res.data)
      //   }
      // })
    },
    fillSchedule () {
      const { baseInfo = {}, visible } = this
      this.showIframeDialog({
        title: '日程安排',
        className: 'dialog-schedule',
        href: `/WEB_PC/av-modules/html/Schedule/1.0.1/Schedule.html?TENDER_PROJECT_CODE=${baseInfo.TENDER_PROJECT_CODE}&SIGN=${visible.issubmit || visible.ispublish ? '1' : '0'}`
      })
    },
    inviteEnterprise (flag) {
      const { baseInfo = {} } = this
      this.showIframeDialog({
        title: flag === 1 ? '邀请企业' : '查看邀请企业',
        className: 'dialog-invite',
        href: `/BidContent/BidInviteEnterprise${flag === 1 ? '' : '_View'}.aspx?TENDER_PROJECT_CODE=${baseInfo.TENDER_PROJECT_CODE}`
      })
    },
    marginPayTypes (flag) {
      // console.log('marginPayTypes 选择保证金银行', arguments)
      const { baseInfo = {} } = this
      this.showIframeDialog({
        title: flag === 1 ? '选择保证金银行' : '查看保证金银行',
        className: 'dialog-margin',
        href: `/BidContent/BidBank${flag === 1 ? '' : 'View'}.aspx?TENDER_PROJECT_CODE=${baseInfo.TENDER_PROJECT_CODE}`,
        call: () => {
          if (flag === 1) {
            this.resetBankInfo()
          }
        }
      })
    },
    save (flag) {
      // console.log('save 暂存', arguments)
      this.validMarginBanks(() => {
        const data = this.buildFormData()
        // 验证招标项目名称
        const keys = Object.keys(data)
        const projectNameKey = keys.find(key => /PROJECT_NAME/.test(key))
        if (!data[projectNameKey]) {
          this.scrollToFormItem(undefined, undefined, 'error-level-8')
          this.$alert('请填写招标项目名称', '操作提示', {
            type: 'error'
          })
          return false
        }
        if (flag > 0) {
          // 验证E1，E2
          const msg = this.validE1E2()
          if (msg) {
            this.$alert(msg, '操作提示', { type: 'error' })
            this.scrollToFormItem(undefined, undefined, 'error-level-7')
            return false
          }          
        }
        // 验证其他字段
        this.validFormData(flag, () => {
          const { t1852_dataList=[], t1928_dataList = [], t1872_dataList = [], ...elseData } = data
          const params = {
            OPtype: 'SaveProjectInfo',
            ID: this.baseInfo.ID,
            Operate: '暂存',
            ...elseData
          }
          const codes = [1854, 1857, 1858, 1859, 1860, 1867, 1869, 1870, 1871, 1872, 1873, 1911, 1912, 1913, 1925, 1926, 1927, 1928, 1929, 1930, 1932, 1933, 1934, 1938, 1939, 1940, 1941, 1943, 1944, 1945, 1946, 1947, 1950, 1951, 1953, 1954, 1956, 1957, 1960, 1967, 1970]
          const tempParams = []
          t1852_dataList.forEach(obj => {
            tempParams.push(obj.t1852_BID_SECTION_CODE)
          })
          for (let key in params) {
            if (params[key] === null || /t1961_/.test(key)) {
              delete params[key]
              continue
            }
            if (/_dataList/.test(key)) {
              params[key] = JSON.stringify(params[key])
            } else if (params[key] === undefined) {
              params[key] = ''
            }
            const tcid = key.replace(/^t(\d{4}).+$/, '$1') - 0
            if (codes.indexOf(tcid) >= 0) {
              params[`t${tcid}_BID_SECTION_CODES_OLD`] = tempParams.join(',')
              params[`t${tcid}_BID_SECTION_CODES`] = tempParams.join(',')
            }
          }
          params.t1852_dataList = JSON.stringify(t1852_dataList)
          params.t1872_dataList = JSON.stringify(t1872_dataList)
          params.t1928_dataList = JSON.stringify(t1928_dataList)

          // if (params) {
          //   console.log('params', params)
          //   return false
          // }

          const { modules } = this
          this.setLoading(true)
          delete params.MARGIN_PAY_TYPE
          console.log('params', params)
          api.form('/JTHandler/ProjectAgentHandler.ashx', params).then(res => {
            this.setLoading(false)

            if (res.status === 0) {
              this.$alert(`提交错误，错误信息：${res.info}`, '提示', { type: 'error' })
            } else if (res.status === 1) {
              // guarantee
              if (modules.electronicMail) {
                this.$electronicMail.commit(() => {
                  if (flag === 1 || flag === 2) {
                    this.submit(flag === 2, params)
                  } else {
                    this.$message.success(res.info || '暂存成功')
                  }
                })
              } else {
                if (flag === 1 || flag === 2) {
                  this.submit(flag === 2, params)
                } else {
                  this.$message.success(res.info || '暂存成功')
                }
              }
               
            }
          })
        })
      })
    },
    submit (flag, params) {
      this.$vm.validate(() => {
        this.$electronicMail.validForm(valid => {
          if (valid) {
            this.sign(flag, params)
          } else {
            this.$alert("请填写完所有电子保函补充信息", "操作提示", {
              customClass: "ctba-message-info",
              type: "info",
            }).then(() => {
              this.$electronicMail.scrollIntoView();
            })
          }
        })
      }, e => {
        this.$alert("请填写完所有必填项", "操作提示", {
          customClass: "ctba-message-info",
          type: "info",
        })
        this.$vm.scrollToFormItem()
      })
    },
    sign (flag, params) {
      const { TYPE, EVALUATION_METHOD, TENDER_PROJECT_CODE } = this.baseInfo
      const { TCIDS, TCIDS_MUT } = this.config
      params.Operate = flag ? '发布' : '提交备案'
      this.setLoading(true)
      api.form('/JTHandler/ProjectAgentHandler.ashx', params).then(res => {
        this.setLoading(false)
        if (res.status === 0) {
          if (/未签章无法提交备案/.test(res.info)) {
            this.setLoading(true)
            api.form('/JTHandler/ProjectAgentHandler.ashx', {

              optype:'GetProjectSignUrl',
              // optype: 'save_pdf',
              // IsData: 1,
              // TCIDS: `${TCIDS},1919,1961`.replace(/^,/, ''),
              // TCIDS_MUT: `${TCIDS_MUT},1946,1947,1942`.replace(/^,/, ''),
               ID: params.ID,
              // TYPE: `${TYPE}-${EVALUATION_METHOD}`,
               TENDER_CODE: TENDER_PROJECT_CODE,
              // Flag: false,
              // ispublish: flag,
            }).then(res => {
              this.setLoading(false)
              if (res.status === 1) {
                this.setSignUrlOptions({
                  result: true,
                  msg: "",
                  json: {
                    url: res.data.sxcaUrl,
                    sx_url: res.data.sxcaUrl,
                    fjggfw_url: res.data.tycaUrl
                  }
                })
              }
            }).catch(() => {
              this.setLoading(false)
            })
          } else {
            this.$alert(`提交错误，错误信息：${res.info}`, '操作提示', { type: 'error' })
          }
        }
      }).catch(() => {
        this.setLoading(false)
      })
    },
    showBasic () {
      // console.log('showBasic 查看基本信息', arguments)
      const { baseInfo = {} } = this
      this.showIframeDialog({
        title: '基本信息',
        className: 'dialog-basic',
        href: `/Home/basicinfo.aspx?baseId=${baseInfo.ID}`
      })
    },
    showFiles () {
      // console.log('showFiles 查看备案材料', arguments)
      const { baseInfo = {} } = this
      this.showIframeDialog({
        title: '备案材料查看',
        className: 'dialog-files',
        href: `/Web_ZH/#/otherBacl?TENDER_PROJECT_CODE=${baseInfo.TENDER_PROJECT_CODE}`,
        width: '795px',
        height: '500px'
      })
    },
    showRecords () {
      // console.log('showRecords 查看操作记录', arguments)
      const { baseInfo = {} } = this
      this.showIframeDialog({
        title: '操作记录',
        className: 'dialog-log',
        href: `/BidContent/NoticeLog.aspx?MODULE=1&NCODE=${baseInfo.ID}`,
        width: '795px',
        height: '500px'
      })
    },
    showSignFile () {
      // console.log('showSignFile 查看签章文件', arguments)
      const { pdfInfo } = this
      window.open(`/FileServer/FileDownload.aspx?guid=${pdfInfo.PDF_GUID}`, '_blank')
    },
    uploadFiles () {
      // console.log('uploadFiles 上传备案材料', arguments)
      const { baseInfo = {} } = this
      this.showIframeDialog({
        title: '备案材料',
        className: 'dialog-files',
        href: `/Web_ZH/index.html#/upfile?id=${baseInfo.TENDER_PROJECT_CODE}`,
        width: '795px',
        height: '500px'
      })
    },
    useHistory () {
      // console.log('useHistory 复用历史项目信息', arguments)
      const { baseInfo = {} } = this
      this.showIframeDialog({
        title: '历史项目',
        className: 'dialog-history',
        href: `/BidContent/ReuseHistoryProject.aspx?baseId=${baseInfo.ID}`
      })
    },
    showIframeDialog ({ title, className, href, width, height, call }) {
      const { iframeDialog } = this
      iframeDialog.title = title
      iframeDialog.className = className
      iframeDialog.href = `${href}&t=${Date.now()}`
      iframeDialog.width = width || '1200px'
      iframeDialog.height = height || '650px'
      iframeDialog.call = () => {
        iframeDialog.href = 'about:blank'
        call && call()
      }
      this.$nextTick(() => {
        iframeDialog.visible = true
      })
    },
    validMarginBanks (call) {
      const { baseInfo, marginBankKeys, form } = this
      const key = marginBankKeys[baseInfo.TYPE] || ''
      const value = form[key]

      if (value === '0') {
        call()
      } else {
        api.post('/BidContent/AjaxHandler/BidBankViewHandler.ashx', {}, {
          OPTYPE: 'getbanklist',
          TENDER_PROJECT_CODE: baseInfo.TENDER_PROJECT_CODE,
          r: Math.random(),
        }).then(res => {
          if (res) {
            if (res.enable) {
              if (res.code === 0 && res.data && res.data.length) {
                call()
              } else {
                this.$alert('该交易中心已经启用保证金系统，请通过顶部按钮选择保证金银行！', '提示', { type: 'error' })
              }              
            } else {
              call()
            }
          } else {
            this.$alert('获取保证金银行数据异常、无法提交！', '提示', { type: 'error' })
          }
        })
      }
    },
    validE1E2 () {
      const { EVALUATION_METHOD, TYPE } = this.baseInfo
      let msg = ''
      if (EVALUATION_METHOD === 21 && [9, 10].indexOf(TYPE) >= 0) {
        const sectionData = this.form.t1852_dataList || []
        sectionData.forEach(({
          t1852_E1_NUMBER: E1,
          t1852_E2_NUMBER: E2,
          t1852_BID_SECTION_NAME
        }) => {
          if (/^\d+-\d+$/.test(`${E1}-${E2}`)) {
            if (E1 == 0 || E2 == 0 || E1 <= E2 || (300 / E1 + 300 / E2) < 100 || (300 / E1 + 300 / E2) > 500) {
              msg = `${t1852_BID_SECTION_NAME} 标段的E1 E2 值不符合要求！`
            }
          }
        })
      }
      return msg
    },
    validFormData (flag, call) {
      if (flag === 0) {
        call()
      } else {
        this.$vm.validate(call, (e) => {
          this.$alert("请正确填写错误表单项", "操作提示", {
            customClass: "ctba-message-info",
            type: "info",
          });
          $vm.scrollToFormItem();
        })        
      }
    },
    buildFormData () {
      const { form } = this
      // 2. 获取表格数据并特殊处理
      if (form.t1852_dataList) {
        form.t1852_dataList.forEach((obj, i) => {
          obj.t1852_UP_DOWM_TYPE = obj.t1852_UP_TYPE === '3' ? '1' : obj.t1852_UP_TYPE
          if (form.t1851_IS_SUBSECTION_MARGIN - 1 === 0) {
            // 分标段缴纳保证金金额
          } else {
            // 统一缴纳保证金字段
            obj.t1852_MARGIN_AMOUNT = form.t1852_MARGIN_AMOUNT
          }
        })
      }
      return this.buildFormFiles({...form})
    },
    buildFormFiles (form) {
      const { FILE_KEYS } = this.config
      FILE_KEYS.forEach(key => {
        form[key] = form[key].map(obj => obj.GUID).join(',')
      })
      return form
    },
    buildGuaranteeData () {
      const { form, baseInfo } = this
      return trafficUtils.buildGuaranteeData(form, baseInfo)
    },
    storageData () {

    }
  }
}
</script>
<style lang="scss" scoped>
.bear-traffic-actions{
  display: flex;
  padding: 10px 0;
  .bta {
    &__left {
      flex: 1;
    }
    &__right {
      text-align: right;
    }
  }
}
.loading-dialog {
  .ld {
    &__message {
      color: black;
      font-size: 14px;
      text-align: center;
      .el-icon {
        margin-right: 10px;
        font-size: 30px;
        vertical-align: middle;
      }
    }
  }
}
.upload-dialog {
  .ud {
    &__title {
      margin: 0 0 30px;
      color: #219FFF;
      font-weight: bold;
      text-align: center;
      font-size: 18px;
    }
    &__upload {
      margin: 0 auto;
      width: 360px;
      text-align: left;
      &__icon {
        margin: 30px 0 0;
        color: #B6C2D1;
        font-size: 75px;
      }
    }
  }
}
</style>
<style lang="scss">
.iframe-dialog, .upload-dialog {
  .__iframe {
    width: 100%;
  }
  .el-dialog {
    &__header {
      margin-right: 0;
      background: #2595E9;
      --el-dialog-title-font-size: 14px;
      --el-dialog-padding-primary: 10px 20px;
      --el-text-color-primary: white;
      &btn {
        width: 40px;
        height: 40px;
        &:hover {
          .el-dialog__close {
            color: white;
            opacity: .7;            
          }
        }
      }
    }
    &__body {
      padding: 0;
    }
    &__footer {
      display: none;
    }
    &__close {
      --el-color-info: white;
    }
  }
}
.dialog-history {
  .__iframe {
    margin-top: 10px;
  }
}
.loading-dialog {
  border-radius: 5px;
  --el-dialog-width: 230px;
  .el-dialog {
    &__header, &__footer {
      display: none;
    }
    &__body {
      --el-dialog-padding-primary: 10px;
    }
  }
}
</style>